import { Section } from "component/section";
import { Text } from "component/text";
import { CART_ICONS } from "pages/cart/interfaces/icon";
import "./style.scss";
import { useRecoilValue } from "recoil";
import { deliveryInfoState, orderState } from "state";

export const SuccessDeliveryInfo = () => {
  const orders = useRecoilValue(orderState);
  const deliveryInfo = useRecoilValue(deliveryInfoState);
  return (
    <Section title={"Thông tin giao hàng"} icon={CART_ICONS.delivery}>
      <div className="success-delivery-info">
        <Text fontSize={15}>
          {orders.customer_name} - {orders.customer_mobile}
        </Text>
        <Text fontSize={15}>
          {orders.customer_address}
          {deliveryInfo.ward.value?.name
            ? `, ${deliveryInfo.ward.value?.name}`
            : ""}
          {deliveryInfo.province.value?.name
            ? `, ${deliveryInfo.province.value?.name}`
            : ""}
        </Text>
        <Text fontSize={15} fontWeight="600" style={{ marginTop: '12px' }}>
          Ghi chú: <Text fontWeight='400'>{deliveryInfo.notes || 'Không có'}</Text>
        </Text>
      </div>
    </Section>
  );
};
